import React, { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const questions = [['¿Cómo accedo al material después de comprar?', 'Inmediatamente después de confirmar el pago por Mercado Pago, recibís el acceso al área de miembros por email. Todo el material está disponible de forma instantánea.'], ['¿Sirve si soy profe de educación física y no entrenador personal?', 'Sí. El sistema aplica a cualquier profesional del movimiento que trabaje con alumnos: profe de ed. física, preparador físico, coach deportivo, especialista en boxeo, funcional, crossfit, pilates y más.'], ['¿Necesito muchos seguidores en Instagram para que funcione?', 'No. El sistema está diseñado para entrenadores con audiencias pequeñas o que recién arrancan. Podés tener 300 seguidores y conseguir clientes de todas formas.'], ['¿Qué incluye el Megapack Entrenadores?', 'Incluye los 6 módulos, 4 bonos, el plan de acción de 90 días y 25 casos documentados de entrenadores reales por disciplina.'], ['¿Cuánto tiempo tarda en dar resultados?', 'El plan está estructurado para 90 días. Algunos elementos podés activar desde la primera semana, como los guiones de WhatsApp.'], ['¿Puedo pagar en cuotas?', 'El pago es único a través de Mercado Pago, que ofrece opciones de cuotas según tu tarjeta. Podés verificar las opciones al momento del pago.']];
export function GuaranteeSection() {
  return <section className="px-5 py-20 sm:px-8 sm:py-28" aria-label="Garantía" data-id="element-47">
      <Reveal className="mx-auto max-w-[640px]" data-id="element-48">
        <div className="rounded-xl border border-gold bg-card p-8 text-center sm:p-10" data-id="element-49">
          <div className="mx-auto grid h-[72px] w-[72px] place-items-center rounded-full border border-gold bg-[#d4af37]/[0.06] text-3xl" aria-hidden="true" data-id="element-50">
            🛡️
          </div>
          <h2 className="mt-6 font-display text-3xl font-bold leading-none tracking-[-0.03em] text-ivory" data-id="element-51">
            Garantía de 7 días, sin preguntas
          </h2>
          <p className="mt-5 whitespace-pre-line leading-7 text-sage" data-id="element-52">
            Si en los primeros 7 días sentís que el sistema no es para vos, te
            devolvemos el 100% del dinero. Sin formularios, sin excusas, sin
            vueltas.{'\n\n'}
            La decisión es sin riesgo. El único costo de no entrar es seguir
            como estás.
          </p>
        </div>
      </Reveal>
    </section>;
}
export function FaqSection() {
  const [openQuestion, setOpenQuestion] = useState(0);
  const reduceMotion = useReducedMotion();
  return <section className="border-y border-[#d4af37]/18 bg-card px-5 py-20 sm:px-8 sm:py-28" aria-label="Preguntas frecuentes" data-id="element-53">
      <div className="mx-auto max-w-4xl" data-id="element-54">
        <Reveal data-id="element-55">
          <SectionHeading centered eyebrow="Preguntas frecuentes" title="Lo que suelen preguntar" data-id="element-56" />
        </Reveal>
        <div className="mt-12 space-y-3" data-id="element-57">
          {questions.map(([question, answer], index) => {
          const isOpen = openQuestion === index;
          const panelId = `faq-answer-${index}`;
          return <div key={question} className="border border-[#d4af37]/20 bg-ink" data-id="element-58">
                <h3 data-id="element-59">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left text-sm font-semibold text-ivory focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-3px] focus-visible:outline-gold sm:px-6" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenQuestion(isOpen ? -1 : index)} data-id="element-60">
                    {question}
                    <PlusIcon className={`shrink-0 text-gold transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} size={21} strokeWidth={1.6} aria-hidden="true" data-id="element-61" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-62">
                  {isOpen ? <motion.div id={panelId} role="region" initial={reduceMotion ? false : {
                opacity: 0,
                y: -6
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={reduceMotion ? {} : {
                opacity: 0,
                y: -6
              }} transition={{
                duration: 0.2,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-63">
                      <p className="px-5 pb-6 leading-7 text-sage sm:px-6" data-id="element-64">
                        {answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}